import React from 'react'
import './header.css'

type Props = React.PropsWithChildren<React.ButtonHTMLAttributes<HTMLButtonElement>>

export const HeaderIconButton = React.forwardRef<HTMLButtonElement, Props>(
  ({ children, className, type = 'button', ...rest }, ref) => {
    const combinedClassName = className ? `HeaderIconButton ${className}` : 'HeaderIconButton'

    return (
      <button type={type} className={combinedClassName} ref={ref} {...rest}>
        {children}
      </button>
    )
  },
)

HeaderIconButton.displayName = 'HeaderIconButton'

export default HeaderIconButton
